'use client'

import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import '../css/TestimonialCarousel.css'

const testimonials = [
  {
    text: "Everything involving Rolf was amazing. He was a fantastic teacher, one of the best I have ever had. The lectures were engaging and very clear. I felt like I learned a lot, he was very kind and understanding, explaining the concepts very well."
  },
  {
    text: "Rolf describes the problems in a very clear way and takes his time to explain things if students do not understand. One of the better lecturers I have had so far."
  },
  {
    text: "One of the most educational courses I have ever had. Great introduction into the world of heuristics. More courses like this are needed, also earlier in the BSC program."
  }
]

const TestimonialCarousel = () => {
  const [index, setIndex] = useState(0)

  const handleNext = () => setIndex((index + 1) % testimonials.length)
  const handlePrev = () => setIndex((index - 1 + testimonials.length) % testimonials.length)

  return (
    <div className="testimonial-container">
      <AnimatePresence mode="wait">
        <motion.div
          key={index}
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -50 }}
          transition={{ duration: 0.4 }}
        >
          <p className="testimonial-text">
            “{testimonials[index].text}”
          </p>
          
        </motion.div>
      </AnimatePresence>
      <div className="carousel-controls">
        <button onClick={handlePrev} className="carousel-button" aria-label="Previous testimonial">
          <ChevronLeft size={28} />
        </button>
        <button onClick={handleNext} className="carousel-button" aria-label="Next testimonial">
          <ChevronRight size={28} />
        </button>
      </div>
    </div>
  )
}

export default TestimonialCarousel;